module.exports = __webpack_public_path__ + "img/bag2.3330806e.svg";